<template>
  <article class="row">
    <section class="col s8">
      <aside class="row">
        <div class="col s12">
          <h5 class="teal-text text-accent-4"><strong>Totals this Month</strong></h5>
          <table>
            <thead>
              <tr>
                <th>Company</th>
                <th>Point Totals</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="[label, points] in aggregateVotes" :key="label">
                <td>
                  <strong>{{ label.split(';')[0] }}</strong>
                  &#8226;
                  {{ label.split(';')[1] | pretty }}
                </td>
                <td>{{ points.join(' + ') }} = <span class="strong">{{ sum(points) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </aside>
      <aside class="row">
        <div class="col s12">
          <h5 class="teal-text text-accent-4"><strong>Votes</strong></h5>
          <bbn-stats-table :votes="votes" />
        </div>
      </aside>
    </section>
    <section class="col s4">
      <h5 class="teal-text text-accent-4"><strong>Publication History</strong></h5>
      <aside class="row" v-for="history in histories" :key="history.edition">
        <div class="col s12">
          <div class="card-panel grey lighten-4">
            <h5 class="orange-text text-accent-4">{{ history.edition }}</h5>
            <table>
              <thead>
                <tr>
                  <th>Ticker</th>
                  <th>Rec'd in Year</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="instrument of history.instruments" :key="instrument.company_id">
                  <td><strong>{{ instrument.symbol }}</strong></td>
                  <td>{{ instrument.count }} time{{ instrument.count !== 1 ? 's' : '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </aside>
    </section>
  </article>
</template>

<script>
import axios from 'axios';
import BestBuysNowStatsTable from '@/components/BestBuysNowStatsTable.vue';

export default {
  name: 'BbnStats',
  components: { BbnStatsTable: BestBuysNowStatsTable },
  props: {
    portfolioId: {
      type: Number,
      required: true,
    },
    edition: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      votes: [],
      histories: [],
      sortField: 'analyst',
    };
  },
  computed: {
    aggregateVotes() {
      const frequencies = new Map();
      this.votes.forEach(vote => {
        const companyLabel = `${vote.instrument.company.instruments};${vote.instrument.company.name}`;
        const currentVal = frequencies.get(companyLabel);
        frequencies.set(companyLabel, currentVal ? currentVal.concat([vote.points]) : [vote.points]);
      });
      return Array.from(frequencies.entries()).sort((a, b) => {
        const [[aLabel, aPoints], [bLabel, bPoints]] = [a, b];
        if (this.sum(aPoints) > this.sum(bPoints)) { return 1; }
        if (this.sum(aPoints) < this.sum(bPoints)) { return -1; }
        return 0;
      }).reverse();
    },
  },
  watch: {
    portfolioId() {
      this.fetchMetadata();
    },
    edition() {
      this.fetchMetadata();
    },
  },
  methods: {
    async fetchMetadata() {
      const promises = [
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/votes/?portfolio_id=${this.portfolioId}&edition=${this.edition}`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/votes/get_rec_stats/${this.portfolioId}/`),
      ];
      const [votesResp, historiesResp] = await Promise.all(promises);
      this.votes = votesResp.data.votes;
      this.histories = historiesResp.data;
    },
  },
  mounted() {
    this.fetchMetadata();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.card-panel {
  border-radius: 10px;
}
</style>
